import { connect } from 'react-redux';
import { get } from 'lodash';

import DeliveryInformation from '../components/DeliveryInformation';

export default connect(
  (state) => ({
    deliverySlot: state.deliverySlot,
    isSeasonalDeliveryAvailable: get(state, 'user.eligibilityDetails.seasonalDeliveryAvailable', false),
  })
)(DeliveryInformation);
